import { IconProps } from '@drift-labs/icons';
import { cj } from 'src/utils/classNames';

export default function Backpack({
	className,
	color,
	size = 16,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				fill="none"
				viewBox="0 0 18 24"
			>
				<path
					fill={color ?? 'currentColor'}
					d="M15.466 17.382c.85 0 1.276 0 1.54.264s.264.69.264 1.54v1.204c0 1.702 0 2.553-.528 3.081-.529.529-1.38.529-3.081.529H4.335c-1.702 0-2.553 0-3.081-.529-.529-.528-.529-1.38-.529-3.08v-1.204c0-.851 0-1.277.264-1.54.265-.265.69-.265 1.541-.265z"
				/>
				<path
					fill={color ?? 'currentColor'}
					fillRule="evenodd"
					d="M8.998 3.469c8.393 0 8.273 5.595 8.273 8.272v3.009a.903.903 0 0 1-.903.902H1.628a.903.903 0 0 1-.903-.902V11.74c0-2.677-.12-8.272 8.273-8.272m0 2.132a2.557 2.557 0 1 0 0 5.114 2.557 2.557 0 0 0 0-5.114"
					clipRule="evenodd"
				/>
				<path
					fill={color ?? 'currentColor'}
					d="M8.996 0c1.81 0 3.396.633 3.815 1.664.063.178.095.267.039.333s-.165.046-.382.007a15 15 0 0 0-2.056-.193 26 26 0 0 0-1.414-.036q-.743 0-1.412.036c-.704.02-1.501.09-2.065.19-.213.036-.319.055-.375-.011s-.025-.153.037-.328C5.6.635 7.185 0 8.996 0"
				/>
			</svg>
		</span>
	);
}
